var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { ToolbarItem } from '@progress/kendo-react-buttons';
import { classNames } from '@progress/kendo-react-common';
/**
 * Represents the default `navigation` component rendered by the [KendoReact Scheduler component]({% slug overview_scheduler %}).
 */
/** @hidden */
export var SchedulerNavigation = React.forwardRef(function (props, ref) {
    var className = props.className, other = __rest(props, ["className"]);
    var element = React.useRef(null);
    React.useImperativeHandle(ref, function () { return ({ element: element.current, props: props }); });
    return (React.createElement(ToolbarItem, __assign({ ref: function (item) { if (item) {
            element.current = item.element;
        } }, className: classNames(className) }, other), props.children));
});
SchedulerNavigation.displayName = 'KendoReactSchedulerSchedulerNavigation';
//# sourceMappingURL=SchedulerNavigation.js.map